import { render, staticRenderFns } from "./SpecialPrices.vue?vue&type=template&id=fde5bd0a&"
import script from "./SpecialPrices.vue?vue&type=script&lang=js&"
export * from "./SpecialPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports